<template>
  <b-form v-if="currentScreen === 'New'" @submit.prevent="nextForm()">
    <b-form-group
      id="input-group-title"
      label="First, name your file."
      label-for="input-title"
      class="mb-4 font-weight-bold"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-input
        id="input-title"
        type="text"
        v-model="file.name"
        required
        placeholder="WA - Driver licence, SA - White card etc."
        :aria-describedby="ariaDescribedby"
      ></b-form-input>

      <b-form-invalid-feedback id="input-title-feedback">
        <!-- eslint-disable-next-line -->
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      id="input-group-title"
      label="Second, select the type of information you would like to add to your file."
      label-for="input-title"
      class="mb-4 font-weight-bold"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-invalid-feedback
        class="mb-2 font-weight-normal"
        :state="infoTypeState"
        >The information types must have at least 1
        item.</b-form-invalid-feedback
      >
      <b-form-checkbox-group
        class="font-weight-normal type-group"
        id="checkbox-types"
        :aria-describedby="ariaDescribedby"
        v-model="selectedInfoTypes"
        name="types"
        stacked
        ><b-form-checkbox
          v-for="type in infoTypes"
          :key="type.id"
          :value="type"
          class="mb-2"
        >
          {{ type.label }}
        </b-form-checkbox>
      </b-form-checkbox-group>

      <b-form-invalid-feedback id="input-title-feedback">
        <!-- eslint-disable-next-line -->
      </b-form-invalid-feedback>
    </b-form-group>

    <!-- <b-form-group
      id="input-group-title"
      label="Finally, choose how many files you would like to upload."
      label-for="input-title"
      class="mb-4 font-weight-bold"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-radio-group
        id="radio-group"
        v-model="file.uploadType"
        required
        :aria-describedby="ariaDescribedby"
        name="upload-type"
        stacked
      >
        <b-form-radio
          name="single"
          value="single"
          class="font-weight-normal mb-2"
          >Single file (perfect for word documents)</b-form-radio
        >
        <b-form-radio
          name="multiple"
          value="multiple"
          class="font-weight-normal"
          >Multiple files / back to front (suitable for licences)</b-form-radio
        >
      </b-form-radio-group>

      <b-form-invalid-feedback id="input-title-feedback">
        eslint-disable-next-line
      </b-form-invalid-feedback>
    </b-form-group> -->

    <b-row class="mt-5">
      <b-col>
        <b-button
          block
          class="btn-outlined bg-white text-dark"
          variant="outline-secondary"
          v-if="isRequestFileCreation"
          :to="{
            name: 'request.request-file-templates-page',
            params: { fileRequestUserId: fileRequestUserId }
          }"
          >Discard</b-button
        >
        <b-button
          v-else
          block
          class="btn-outlined bg-white text-dark"
          variant="outline-secondary"
          :to="{ name: 'file.list-page' }"
          >Discard</b-button
        >
      </b-col>
      <b-col>
        <b-button block type="submit" variant="primary">
          Next
        </b-button>
      </b-col>
    </b-row>
  </b-form>
  <file-form
    v-else
    :file="file"
    :selectedFields="selectedInfoTypes"
    :isRequestFileCreation="isRequestFileCreation"
    :request="request"
    @back="currentScreen = 'New'"
  />
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Form from '@/utils/form'
import FileForm from '@/components/forms/FileForm'

export default {
  name: 'NewFileForm',

  components: {
    FileForm
  },

  props: {
    isRequestFileCreation: {
      type: Boolean,
      default: false
    },
    fileRequestUserId: {
      type: [Number, String],
      default: null
    },
    request: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      file: new Form({
        name: '',
        uploadType: ''
      }),
      selectedInfoTypes: [],
      currentScreen: 'New',
      infoTypeState: null
    }
  },

  computed: {
    ...mapState({
      infoTypes: state => state.file.infoTypes
    })
  },

  methods: {
    ...mapActions({
      getInfoTypes: 'file/getInfoTypes',
      fileRequestShare: 'requests/fileRequestShare'
    }),
    ...mapMutations({
      setCurrentScreen: 'file/setCurrentScreen'
    }),
    nextForm() {
      this.infoTypeState = this.selectedInfoTypes.length >= 1
      if (this.infoTypeState) {
        this.currentScreen = 'Upload'
      }
    }
  },

  watch: {
    currentScreen(value) {
      this.setCurrentScreen(value)
    },

    request(newVal, oldVal) {
      if (this.isRequestFileCreation && newVal) {
        this.file.name = newVal.name
        this.selectedInfoTypes = newVal.information_types

        this.nextForm()
      }
    },

    selectedInfoTypes(value) {
      this.infoTypeState = value.length >= 1
    }
  },

  created() {
    this.getInfoTypes()
  }
}
</script>

<style lang="scss" scoped>
.type-group {
  column-count: 2;

  @media (min-width: 767px) {
    padding-right: 10em;
  }
}
</style>
